module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', [_c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.organizationSettings.title')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper org-settings"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.general'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.settings.generalSettings')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.generalSettingsFormSet1,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.generalSettingsFormSet2,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  }), _vm._v(" "), _vm._l((_vm.tagsOptions), function(item, key) {
    return _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showTagOptions(key))
      }
    })
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.ediNotifyRecipients.title')))]), _vm._v(" "), _vm._l((_vm.ediNotificationRecipients), function(email) {
    return _c('el-tag', {
      key: email,
      staticClass: "edi-notification-recipients",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.ediNotifyRecipHandleClose(email)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(email) + "\n                  ")])
  }), _vm._v(" "), (_vm.ediNotifyRecipInputVisible) ? _c('el-input', {
    ref: "saveEmailInput",
    staticClass: "input-new-tag",
    class: _vm.ediNotifyRecipInvalidValue ? 'danger' : '',
    attrs: {
      "size": "medium"
    },
    on: {
      "blur": _vm.ediNotifyRecipHandleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ediNotifyRecipHandleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.ediNotifyRecipInputValue),
      callback: function($$v) {
        _vm.ediNotifyRecipInputValue = $$v
      },
      expression: "ediNotifyRecipInputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.ediNotifyRecipShowInput
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('static.organizationSettings.ediNotifyRecipients.addBtn')))]), _vm._v(" "), (_vm.ediNotifyRecipInvalidValue) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.ediNotifyRecipInvalidValue) + " ")]) : _vm._e()], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.lowStockNotifyRecipients.title')))]), _vm._v(" "), _vm._l((_vm.lowStockNotificationRecipients), function(email) {
    return _c('el-tag', {
      key: email,
      staticClass: "edi-notification-recipients",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.lowStockNotifyRecipHandleClose(email)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(email) + "\n                    ")])
  }), _vm._v(" "), (_vm.lowStockNotifyRecipInputVisible) ? _c('el-input', {
    ref: "saveEmailInputLowStock",
    staticClass: "input-new-tag",
    class: _vm.lowStockNotifyRecipInvalidValue ? 'danger' : '',
    attrs: {
      "size": "medium"
    },
    on: {
      "blur": _vm.lowStockNotifyRecipHandleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.lowStockNotifyRecipHandleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.lowStockNotifyRecipInputValue),
      callback: function($$v) {
        _vm.lowStockNotifyRecipInputValue = $$v
      },
      expression: "lowStockNotifyRecipInputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.lowStockNotifyRecipShowInput
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('static.organizationSettings.lowStockNotifyRecipients.addBtn')))]), _vm._v(" "), (_vm.lowStockNotifyRecipInvalidValue) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.lowStockNotifyRecipInvalidValue) + " ")]) : _vm._e()], 2)], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.settings.productDisplay')))]), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tag) + "\n                  ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-select', {
    ref: "saveTagInput",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }, _vm._l((_vm.tagsOptions), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item.label,
        "value": key
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(key))])])
  }), 1) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('static.settings.newField')))])], 2)])], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.generalSettingsFormSet1.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.email'),
      "name": "2"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.messageTemplates')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.messagesFormSet1,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.messagesFormSet2,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.messagesFormSet3,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.messagesFormSet4,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.messagesFormSet5,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.messagesFormSet1.loading
    },
    on: {
      "click": _vm.saveMessages
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.isOnlineBooking) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.booking'),
      "name": "3"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.booking')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.bookingSettingsSet1,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.bookingSettingsSet1.loading
    },
    on: {
      "click": _vm.saveBooking
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.accounting'),
      "name": "4"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.payment_identification')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.accountingFormSet2,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  }), _vm._v(" "), (!_vm.settings.paymentIdentitificationGeneration && !_vm.settings.paymentIdentitificationTemplate) ? [_c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.accountingFormSet2.loading
    },
    on: {
      "click": _vm.saveBilling
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.accounting')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.accountingFormSet1,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.accountingFormSet1.loading
    },
    on: {
      "click": _vm.saveAccounting
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.coa.title')))]), _vm._v(" "), _c('chart-of-accounts')], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.emailInvoiceCopy.title')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.emailInvoiceCopyForm,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.emailInvoiceCopyForm.loading
    },
    on: {
      "click": _vm.saveEmailInvoiceCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), (_vm.isEDI) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.shippingProvider'),
      "name": "5"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('shipping-provider-table')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (true === _vm.checkProjectModule) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.project'),
      "name": "6"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('project-table')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.accountInformation.advance'),
      "name": "7"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [(_vm.bulkPriceUpdateStatus === 'running') ? _c('div', [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.running.title')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.running.description')))])]) : _vm._e(), _vm._v(" "), (_vm.bulkPriceUpdateStatus === 'failed') ? _c('div', [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.failed.title')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.failed.description')))])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.bulk_price_update')))]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.advanceFormSet,
      "translation": "form.organizationSettings",
      "hasLabel": true,
      "labelWidth": "180px"
    }
  }), _vm._v(" "), [_c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.bulkPriceUpdateStatus === 'running' || _vm.bulkPriceUpdateStatus === 'failed'
    },
    on: {
      "click": _vm.bulkPriceUpdateModal
    }
  }, [_vm._v(_vm._s(_vm.$t('button.bulkPriceUpdate').toUpperCase()))])], 1) : _vm._e()]], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.bulk_price_update_entries.title')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": [].concat( _vm.bulkPriceUpdateEntries ).reverse(),
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date_time",
      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.date'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.status ? _vm.$t(("static.organizationSettings." + (scope.row.status))) : ''))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "percentage",
      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.percentage'),
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rounding_rules",
      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.roundingRules'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.priceTypes')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getPriceTypes(scope.row.price_types))
          }
        })]
      }
    }])
  })], 1)], 1)])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f12a14","hasScoped":false}!./src/app/pages/withNavigation/profile/settings/settings.html
// module id = 3064
// module chunks = 1